<div class="dialog-container">
    <h1>Comming Soon</h1>
    <button mat-button (click)="closeDialog()">Close</button>
</div>